import { createSelector } from 'reselect'


const getNav = (state) => state.nav

export const getSelectorNav = createSelector(
  [getNav],
  (nav) => {
    const { topnavSection, displayMainHeader, isLoading, isFetching } = nav
    return { topnavSection, displayMainHeader, isLoading, isFetching }
  },
)
